import React, { FC, useEffect, useState } from 'react'
import { PartnersLocatorFilters as DropdownContainer } from '../../../../partners/partnerListings'

type Props = {
  listingYears: any
  handleFilterItemClick: any
  listingTypes: any
  mobileYearFilterText: any
  typeSelection: any
  yearSelection: any
}

export const Select: FC<Props> = ({
  listingYears,
  handleFilterItemClick,
  listingTypes,
  mobileYearFilterText,
  typeSelection,
  yearSelection,
}) => {
  const yearOptions = listingYears
  const typeOptions = [listingTypes.PRESS_RELEASES, listingTypes.MEDIA_COVERAGE]

  const [typeFilter, setTypeFilter] = useState(typeSelection)
  const [isTypeFilterActive, setIsTypeFilterActive] = useState(false)
  const [yearFilter, setYearFilter] = useState(yearSelection[0])
  const [isYearFilterActive, setIsYearFilterActive] = useState(false)

  //* handles state transitions from buttons to dropdown
  useEffect(() => {
    setTypeFilter(typeSelection)
    setYearFilter(yearSelection[0])
  }, [typeSelection, yearSelection])

  const handleFilterClick = (e: any) => {
    e.preventDefault()
    setIsTypeFilterActive(false)
    setIsYearFilterActive(false)

    if (e.target.id === 'type' || e.target.parentElement.id === 'type') {
      setIsTypeFilterActive(!isTypeFilterActive)
    } else if (e.target.id === 'year' || e.target.parentElement.id === 'year') {
      setIsYearFilterActive(!isYearFilterActive)
    }
  }

  const handleFilterItemClickCurr = (e: any) => {
    e.preventDefault()

    if (e.target.getAttribute('data-item') === 'type') {
      if (Object.values(listingTypes).includes(e.target.textContent)) {
        setTypeFilter(e.target.textContent)
        handleFilterItemClick(e.target.textContent, null, true)
      }

      setIsTypeFilterActive(false)
    } else if (e.target.getAttribute('data-item') === 'year') {
      if (e.target.textContent === mobileYearFilterText) {
        setYearFilter(mobileYearFilterText)
        handleFilterItemClick(null, [], true)
      } else {
        setYearFilter(e.target.textContent)
        handleFilterItemClick(null, [e.target.textContent], true)
      }

      setIsYearFilterActive(false)
    }
  }

  return (
    <DropdownContainer className="PartnersLocatorFilters">
      <div className="Jobs__FiltersContainer">
        <div className="PartnersLocator__filter">
          <div
            id="type"
            className={`PartnersLocator__filterClosed ${isTypeFilterActive ? 'is-active' : ''}`}
            onClick={handleFilterClick}>
            <span>{typeFilter ? typeFilter : 'All Articles'}</span>
          </div>

          <div className={`PartnersLocator__filterOpened ${isTypeFilterActive ? 'is-active' : ''}`}>
            <ul>
              <li key="All_Articles_1" data-item="type" onClick={handleFilterItemClickCurr}>
                {listingTypes.ALL_ARTICLES}
              </li>

              {typeOptions &&
                typeOptions.map((type: any, index: any) => (
                  <li key={`type_${index}`} data-item="type" onClick={handleFilterItemClickCurr}>
                    {type}
                  </li>
                ))}
            </ul>
          </div>
        </div>

        <div className="PartnersLocator__filter">
          <div
            id="year"
            className={`PartnersLocator__filterClosed ${isYearFilterActive ? 'is-active' : ''}`}
            onClick={handleFilterClick}>
            <span>{yearFilter ? yearFilter : mobileYearFilterText}</span>
          </div>

          <div className={`PartnersLocator__filterOpened ${isYearFilterActive ? 'is-active' : ''}`}>
            <ul>
              <li key="All_Years_1" data-item="year" onClick={handleFilterItemClickCurr}>
                {mobileYearFilterText}
              </li>

              {yearOptions &&
                yearOptions.map((year: any, index: any) => (
                  <li key={`year_${index}`} data-item="year" onClick={handleFilterItemClickCurr}>
                    {year}
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </DropdownContainer>
  )
}
